module.exports = __webpack_public_path__ + "static/media/1-min.76eb1990.JPG";